import { memo, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import check from 'check-types';
import { Alert, Panel } from '@sdflc/ui';

import { LocalizationContext } from '../../../contexts';
import { OrderSubscriptionByDistanceListItem } from './OrderSubscriptionByDistanceListItem';

const tplNewUserSubscribeListItem = Array.from({ length: 2 }).map((_, idx) => ({
  id: idx,
  userLocationId: null,
  distanceKm: 5,
  status: 100,
}));

const OrderSubscriptionsByDistanceList = memo((props) => {
  const { onClickAction, list, items, listOp, removingOps, updatingOps } =
    props;
  const { getText } = useContext(LocalizationContext);

  useEffect(() => {
    // Load user contacts if they were not yet loaded

    if (!listOp.called && check.function(list)) {
      list({
        filter: {},
        params: {},
      });
    }
  }, [list, listOp]);

  if (
    listOp.called &&
    !listOp.result.isInProgress() &&
    listOp.result.didFail()
  ) {
    return <Alert variant='danger'>{listOp.result.getErrorSummary()}</Alert>;
  }

  const items2use = listOp.result?.isInProgress()
    ? tplNewUserSubscribeListItem
    : items;

  return (
    <Panel mt={2} p={1} overflow='initial'>
      {items2use.map((item) => {
        return (
          <OrderSubscriptionByDistanceListItem
            key={item.id}
            value={item}
            onClickAction={onClickAction}
            loading={listOp.result?.isInProgress()}
            removingResult={removingOps[item.id]?.result}
            updatingResult={updatingOps[item.id]?.result}
          />
        );
      })}
      {!listOp.result?.isInProgress() && items.length === 0 && (
        <Alert variant='default'>
          {getText('blocks.orderSubscriptionByDistance.noItems')}
        </Alert>
      )}
    </Panel>
  );
});

OrderSubscriptionsByDistanceList.displayName =
  'OrderSubscriptionsByDistanceList';

OrderSubscriptionsByDistanceList.propTypes = {
  onClickAction: PropTypes.func,
  list: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  listOp: PropTypes.any,
  updatingOps: PropTypes.any,
  removingOps: PropTypes.any,
};

OrderSubscriptionsByDistanceList.defaultProps = {
  onClickAction: null,
};

export { OrderSubscriptionsByDistanceList };
